import React, { useState } from 'react';
import { mapQueryFor, mapsQueryUrl, mapEmbedSrc } from '../utils/links';

function MapSection({ restaurant }) {
  const query = mapQueryFor(restaurant);
  const caption = restaurant
    ? `Showing ${restaurant} locations near you.`
    : 'Pick a restaurant above to drop a pin — or explore wing spots nearby.';

  // Show a shimmer placeholder until the iframe reports it has loaded.
  // Track which query finished loading so the placeholder returns whenever
  // the restaurant (and thus the map query) changes.
  const [loadedQuery, setLoadedQuery] = useState(null);
  const loaded = loadedQuery === query;

  return (
    <div style={{ marginTop: 40 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          marginBottom: 8,
          flexWrap: 'wrap',
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: 21,
            lineHeight: '28px',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            color: '#f5f5f7',
          }}
        >
          📍 Find it on the map
        </h2>
        <a
          href={mapsQueryUrl(query)}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 14,
            fontWeight: 600,
            color: '#0a84ff',
            textDecoration: 'none',
            background: 'rgba(10,132,255,.18)',
            padding: '8px 15px',
            borderRadius: 999,
          }}
        >
          Open in Google Maps ↗
        </a>
      </div>
      <p style={{ margin: '0 0 14px', fontSize: 14, color: '#98989d' }}>{caption}</p>
      <div
        style={{
          position: 'relative',
          borderRadius: 16,
          overflow: 'hidden',
          boxShadow: '0 8px 32px rgba(0,0,0,.5)',
          border: '1px solid #38383a',
          height: 320,
        }}
      >
        {!loaded && (
          <div
            className="rtr-map-loading"
            aria-hidden="true"
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#98989d',
              fontSize: 14,
            }}
          >
            Loading map…
          </div>
        )}
        <iframe
          key={query}
          title="Google Map"
          src={mapEmbedSrc(query)}
          width="100%"
          height="320"
          onLoad={() => setLoadedQuery(query)}
          style={{
            display: 'block',
            border: 0,
            width: '100%',
            position: 'relative',
            opacity: loaded ? 1 : 0,
            transition: 'opacity 300ms ease',
          }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}

export default MapSection;
